import { makeStyles } from '@material-ui/core/styles';

// Tabs use the platform pill style from the shared MUI theme (MuiTabs / MuiTab overrides).
// Kept as an (empty) hook so existing callers keep working.
export const getBorrowerPortalTabStyles = makeStyles(() => ({
  tabRoot: {},
}));
